import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import TransmittalConfirmDialog from "../../../Dialog/TransmittalConfirmDialog";
// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LockScreenLoading from "../../../LockScreenLoading/LockScreenLoading";
import useLoading from "../../../Loading/useLoading";

// Custom Component
import Legend from "../../../Legend/Legend";
import AttachmentChip from "../../../Chip/AttachmentChip";
import { ckEditorToolbar } from "../../../../global/ckEditor";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";

import { generateRFI, generatePdf } from "../../../../dataSource/rfi";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));

const responseTypeList = [
  {
    code: "noted",
    displayName: "Noted and not my group to reply",
  },
  {
    code: "nocomment",
    displayName: "No advise comment",
  },
  {
    code: "givecomment",
    displayName: "Give comment",
  },
];

const RFIResponseHistory = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  // Use redux data
  const submissionRFIDetailRedux = useSelector(
    (state) => state.submissionRFIDetailRedux
  );

  const {
    submissionValue,
    rfi_seq,
    userStageAction,
    noneditViewFileAction,
    getDetailsShowLoading,
    getDetailsHiddenLoading,
    reponseHistoryValue,
    setResponseHistoryValue,
    fromRFI,
  } = props;

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    id: "",
    material: "",
    ref_no: "",
    atthDate: null,
    description: "",
    attachments: {},
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const [transRFITemplate, setTransRFITemplate] = useState({
    id: "",
    material: "RFI",
    ref_no: "",
    atthDate: null,
    description: "",
    transmittal: [],
    messages: {
      parent_seq: 0,
      content: "",
      dms_property_seqs: [],
      files: [],
    },
  });

  const [submissionTransmittalValue, setSubmissionTransmittalValue] = useState({
    recipients: {
      RESPONSIBLE: [],
      APPROVE: [],
      CONSULTANT: [],
      ARCHITECT: [],
      TO: [],
    },
    attention: "",
    xmtldate: null,
    following: [],
    purpose: [],
    remarks: "",

    documents: [],
  });
  // const [reponseHistoryValue, setResponseHistoryValue] = useState({
  //   transmittal: [],
  // });
  const [rfiAttachment, setRFIAttachment] = useState({
    atth: [],
    response_atth: [],
  });
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [progressTitle, setProgressTitle] = useState("");
  // CKEditor Config
  const editorConfiguration = {
    toolbar: ckEditorToolbar,
  };
  const handleToTransmittal = (response_seq) => (event) => {
    const { checked } = event.target;
    const data = { ...reponseHistoryValue };
    if (checked) {
      data.transmittal.push(response_seq);
      setResponseHistoryValue({ ...reponseHistoryValue, ...data });
    } else {
      if (data.transmittal.indexOf(response_seq) > -1) {
        data.transmittal.splice(data.transmittal.indexOf(response_seq), 1);
        setResponseHistoryValue({ ...reponseHistoryValue, ...data });
      }
    }
  };

  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      material: data.material,
      ref_no: data.ref_no,
      atthDate: data.atthDate,
      description: data.description,
      rfi_seq: data.rfi_seq,
      transmittal: data.transmittal,
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setConfirmDialogOpen(true);
  };

  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };

  const savePDF = () => {
    rfiAttachment.rfi_seq = rfi_seq;
    rfiAttachment.ref_no = submissionValue.ref_no;
    rfiAttachment.transmittal = reponseHistoryValue.transmittal;
    setLockScreenLoadingOpen(true);

    generateRFI(rfiAttachment).then((res) => {
      setLockScreenLoadingOpen(false);
    });
  };
  const sendToTransmittal = () => {
    transRFITemplate.material = `${submissionValue.ref_no}.pdf`;
    transRFITemplate.ref_no = submissionValue.ref_no;
    transRFITemplate.atthDate = submissionValue.createdate;
    confirmDialogHandleOpen({
      material: transRFITemplate.material,
      ref_no: transRFITemplate.ref_no,
      atthDate: transRFITemplate.atthDate,
      description: transRFITemplate.description,
      transmittal: reponseHistoryValue.transmittal,
      rfi_seq: submissionValue.rfi_seq,
      dialogTitle: "Please add details for the Transmittal ",
      dialogContent: "Are you sure to add this RFI to Transmittal?",
      cancelAction: confirmDialogHandleClose,
    });
  };

  return (
    <Fragment>
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <TransmittalConfirmDialog
        open={confirmDialogOpen}
        material={confirmDialogData.material}
        ref_no={confirmDialogData.ref_no}
        atthDate={confirmDialogData.atthDate}
        transmittal={confirmDialogData.transmittal}
        rfi_seq={confirmDialogData.rfi_seq}
        description={confirmDialogData.description}
        setTransRFITemplate={setTransRFITemplate}
        transRFITemplate={transRFITemplate}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        submissionValue={submissionTransmittalValue}
        setSubmissionValue={setSubmissionTransmittalValue}
        fromRFI={true}
        // buildAlert={buildAlert}
        // confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
        confirmDialogHandleClose={confirmDialogHandleClose}
      />
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Typography variant="subtitle1" className={classes.headerText}>
            History Of Response
          </Typography>
          <Divider className={classes.divider} />

          {submissionValue.responses && submissionValue.responses.length > 0 ? (
            submissionValue.responses.map((obj, index) => {
              return (
                <div key={index}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      className={classes.subHeaderText}
                    >
                      {`${obj.rcpt_category} Message #${index + 1}`}
                    </Typography>
                    {userStageAction.IS_TRANSMITTABLE === "Y" && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              reponseHistoryValue.transmittal.indexOf(
                                obj.response_seq
                              ) > -1
                                ? true
                                : false
                            }
                            name={String(obj.response_seq)}
                            color="primary"
                            onChange={handleToTransmittal(obj.response_seq)}
                          />
                        }
                        label="To Transmittal"
                      />
                    )}
                  </div>
                  <Divider className={classes.divider} />

                  {obj.attachments.length >= 0 && (
                    <>
                      <div className={classes.messageAttachment}>
                        <Legend id="file_attachment" label="ATTACHMENTS">
                          {userStageAction.IS_ATTACHMENT_READABLE === "Y" ? (
                            <div className={classes.messageAttachmentArea}>
                              {obj.attachments.length > 0
                                ? obj.attachments.map((aobj, index) => {
                                    return (
                                      <AttachmentChip
                                        key={aobj.file_seq}
                                        id={aobj.file_seq}
                                        filename={aobj.filename}
                                        fileSize={aobj.filesize}
                                        fileExtension={aobj.extension}
                                        viewFileAction={() =>
                                          noneditViewFileAction(
                                            "rfirespond",
                                            aobj.atth_seq
                                          )
                                        }
                                        downloadFileAction={() =>
                                          props.downloadFileAction(
                                            "rfirespond",
                                            aobj.atth_seq
                                          )
                                        }
                                        fileRemoveAction={null}
                                      />
                                    );
                                  })
                                : "No Attachments"}
                            </div>
                          ) : (
                            <h3 style={{ color: "red" }}>
                              You have no permission to read file attachments
                            </h3>
                          )}
                        </Legend>
                      </div>
                      <Divider className={classes.divider} />
                      <Legend id="content" label="CONTENT">
                        <CKEditor
                          editor={ClassicEditor}
                          data={obj.response_content}
                          config={editorConfiguration}
                          disabled={true}
                        />
                      </Legend>
                    </>
                  )}
                  <div>
                    <Typography variant="subtitle1">
                      {`Response Type: ${
                        responseTypeList.filter(
                          (res) => res.code === obj.response_type
                        )[0].displayName
                      }`}
                    </Typography>
                    <Typography variant="subtitle1">
                      From:
                      <div className={classes.itemText}>
                        {obj.respondent_name}
                      </div>
                    </Typography>
                    <Typography variant="subtitle1">
                      Company Name:
                      <div className={classes.itemText}>{obj.company_name}</div>
                    </Typography>
                    <Typography variant="subtitle1">
                      Date:
                      <div className={classes.itemText}>
                        {obj.responded_date}
                      </div>
                    </Typography>
                    <Divider className={classes.divider} />
                  </div>
                </div>
              );
            })
          ) : (
            <h3 style={{ color: "red" }}>No History Response</h3>
          )}
          {userStageAction.IS_TRANSMITTABLE === "Y" && (
            <>
              <Button
                variant="contained"
                color="primary"
                className={classes.formBtn}
                onClick={savePDF}
              >
                Download Rfi
              </Button>
              {fromRFI && (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.formBtn}
                  onClick={sendToTransmittal}
                >
                  Send To Transmittal
                </Button>
              )}
            </>
          )}
        </Box>
      </Grid>
    </Fragment>
  );
};

export default RFIResponseHistory;
